import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AccessControlService } from './access-control.service';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';

export const accessControlResolver: ResolveFn<any> = () => {
  const accessService: AccessControlService = inject(AccessControlService);
  const apiCallList: Observable<any>[] = [];
  const fromResolver = true;

  if (accessService.pageType) {
    if (!(accessService.pageType in accessService.fieldAccess$()))
      apiCallList.push(accessService.getFieldAccess(null, fromResolver)?.pipe(map(val => { return { 'fieldAccessJson': val } })));

    if (!(accessService.pageType in accessService.userActionAccess$()))
      apiCallList.push(accessService.getUserActionAccess(null, fromResolver)?.pipe(map(val => { return { 'userActionAccessJson': val } })));
  }

  if (apiCallList.length)
    return forkJoin(apiCallList).pipe(
      map((val: any[]) => {
        if (val.length) {
          val.forEach((item: any) => {
            if (Object.hasOwn(item, 'fieldAccessJson')) accessService.fieldAccess$.update(fields => ({ ...fields, [accessService.pageType]: item['fieldAccessJson'] }));
            else if (Object.hasOwn(item, 'userActionAccessJson')) accessService.userActionAccess$.update(fields => ({ ...fields, [accessService.pageType]: item['userActionAccessJson'] }));
          });
          return of(true)
        }
        console.log('ERROR : resolved value is empty');
        return of(false);
      }),
      catchError(() => {
        console.log('ERROR : json api call failed');
        return of(false);
      })
    );
  return of(true);
};
